import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const uploadResume = createApiThunk<string, { resume: File }>(
  "fundingRequests/uploadResume",
  async ({ resume }: { resume: File }, { extra: { sharedRepository } }) => {
    return sharedRepository!.uploadDocument(resume);
  },
);

export const resetUploadResume = createAction("fundingRequests/resetUploadResume");
